import { Contact } from "./Components/Contact";
import { Header } from "./Components/Header";
import { Work } from "./Components/Work";

export function Home() {
 return (
  <div className="overflow-x-hidden">
   <div className="w-screen h-full bg-bgcolor">
    <Header />
    <Work />
    <br />
    <Contact />

    <div className="flex items-center justify-between px-8 pb-2">
     <p className="text-slate-600 text-sm">
      © yacoreq | Designed by yacoreq 2025
     </p>

     <div className="flex gap-4">
      <a className="text-slate-600 text-sm" href="/media/regulamin">
       Regulamin
      </a>
      <a className="text-slate-600 text-sm" href="/media/polityka_prywatnosci">
       Polityka prywatności
      </a>
     </div>
    </div>



   </div>
  </div>
 );
}
